module.exports = __webpack_public_path__ + "static/img/9.c50fa5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/9.png
// module id = NNi1
// module chunks = 0